import { fetchWrapper } from '../helpers';

export const mailService = {
  sendContact,
  sendCompany
};

const baseUrl = `${process.env.BASE_URL}/api/mail`;

function sendContact(params) {
  return fetchWrapper.post(`${baseUrl}/contact`, params);
}

function sendCompany(params) {
  return fetchWrapper.post(`${baseUrl}/company-add`, params);
}
